import React, { useState } from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would validate credentials here
    navigate('/app');
  };
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-306">
      <div className="w-full max-w-md" data-id="element-307">
        <div className="mb-8 text-center" data-id="element-308">
          <div className="flex items-center justify-center space-x-2 mb-6" data-id="element-309">
            <div className="w-10 h-10 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-310">
              <span className="text-white text-xl font-bold" data-id="element-311">T</span>
            </div>
            <span className="text-2xl font-bold text-gray-900" data-id="element-312">TaxTidy</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-313">
            Willkommen zurück
          </h1>
          <p className="text-gray-600" data-id="element-314">
            Melde dich an, um deine Buchhaltung zu verwalten
          </p>
        </div>
        <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-315">
          <form onSubmit={handleSubmit} data-id="element-316">
            <div className="space-y-6" data-id="element-317">
              <div data-id="element-318">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-319">
                  E-Mail
                </label>
                <div className="relative" data-id="element-320">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-321">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-322" />
                  </div>
                  <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="ihre@email.de" required data-id="element-323" />
                </div>
              </div>
              <div data-id="element-324">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-325">
                  Passwort
                </label>
                <div className="relative" data-id="element-326">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-327">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-328" />
                  </div>
                  <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="••••••••" required data-id="element-329" />
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-330">
                <div className="flex items-center" data-id="element-331">
                  <input id="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-332" />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-333">
                    Angemeldet bleiben
                  </label>
                </div>
                <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-334">
                  Passwort vergessen?
                </a>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition font-medium" data-id="element-335">
                Anmelden
              </button>
            </div>
          </form>
        </div>
        <p className="mt-6 text-center text-gray-600" data-id="element-336">
          Noch kein Konto?{' '}
          <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-337">
            Jetzt registrieren
          </a>
        </p>
      </div>
    </div>;
};